













































import Vue from 'vue'

import TitleName from '../atoms/TitleName.vue'
import SubjectTitle from '../atoms/SubjectTitle.vue'
import ModalItem from '../organisms/ModalItem.vue'
import ReturnButton from '../atoms/ReturnButton.vue'
import ContentHeaderSection from '../organisms/ContentHeaderSection.vue'
import ContentSectionManabi from '../organisms/ContentSectionManabi.vue'
import { icons } from '../../constants/icons'

export type DataType = {
  icons?: any
  subjects: Array<{
    name: string
    furigana: string
    anchor: string
    color: string
    subject_id?: number
    backgroundColor: string
  }>
  childRefs: Record<string, HTMLElement[]>
}

export default Vue.extend({
  components: {
    TitleName,
    SubjectTitle,
    ModalItem,
    ReturnButton,
    ContentHeaderSection,
    ContentSectionManabi
  },
  data(): DataType {
    return {
      icons: icons,
      subjects: [
        {
          name: '国語',
          furigana: '国語',
          anchor: 'japanese',
          color: 'white',
          backgroundColor: '#ff7f05',
          subject_id: 1,
        },
        {
          name: '算数',
          furigana: '算数',
          anchor: 'math',
          color: 'white',
          backgroundColor: '#3ea8bb',
          subject_id: 2,
        },
        {
          name: '思考の達人ツール',
          furigana: (
            (this.$store.state.grade && parseInt(this.$store.state.grade.name[1]) < 5)
               ? '<ruby>思考<rt>しこう</rt></ruby>の<ruby>達人<rt>たつじん</rt></ruby>ツール'
               : '思考の達人ツール'
          ),
          anchor: 'thinking_tool',
          color: 'white',
          backgroundColor: '#52bb70',
          subject_id: 4,
        },
        {
          name: '複合教科問題',
          furigana:
            '<ruby>複合教科問題<rt>ふくごうきょうかもんだい</rt></ruby>',
          anchor: 'combination_problem',
          color: 'white',
          backgroundColor: '#8677c3',
          subject_id: 3,
        },
        {
          name: 'えい語',
          furigana: 'えい<ruby>語<rt>ご</rt></ruby>',
          anchor: 'English1',
          color: 'white',
          backgroundColor: '#fc7e7e',
          subject_id: 5,
        },
      ],
      childRefs: {} as Record<string, HTMLElement[]>,
    }
  },
  computed: {
    year() {
      return this.$store.state.year
    },
    month() {
      if (!this.$store.state.month) return ''
      return this.$store.state.month
    },
    grade() {
      return this.$store.state.grade
    },
    selectedContract() {
      if (!this.year || !this.month) return null
      const selectedMonth = this.year.toString() + ('0'+this.month).slice(-2)
      return this.$store.state.contracts.find((contract: any) => contract.month === selectedMonth)
    },
    selectedGrade() {
      const contract = (this as any).selectedContract
      return contract ? contract.grade : null
    },
    contents() {
      return this.$store.state.contents
    },
    currentYear(){
      if (!this.$store.state.month) return ''
      return this.$store.state.month > 3 ? this.$store.state.year: this.$store.state.year - 1
    },
    returnUrl() {
      return `${process.env.VUE_APP_ROOT_PATH}/participant/my-page`
    },
    untilMonth() {
      if (!this.month) return ''

      // grade6 month6~3
      if (this.selectedContract != null && this.selectedContract.course === 'S6') {
        if (this.month >= 6) {
          return ((this as any).year + 1) + '年' + 4
        } else if (this.month <= 3) {
          return ((this as any).year) + '年' + 4
        }
      }

      if (this.month > 1){
        return ((this as any).year + 1) + '年' + ((this as any).month -1)
      } else {
        return ((this as any).year) + '年' + 12
      }
    },
  },
  async created() {
    const memberId = this.$cookies.get('member_id')
    const initialFlag = this.$cookies.get('initial_flag') === 'true'

    if (initialFlag) {
      this.$store.commit('SET_CONTENTS', {})
      this.$store.commit('SET_GRADE', {grade: null})
    }
    this.$store.commit('SET_MEMBERID', { memberId: memberId })
    this.$store.dispatch('getCurrentDate')
    if (!initialFlag) return
    this.$cookies.set('initial_flag', false)

    await this.$store.dispatch('getContents')

    const today = new Date(this.$store.state.currentDate)

    const yearMonthValues = Object.entries(this.contents)
      .filter(([t, data]) => {
        if (!(data as any).release_time) return false
        const release = new Date((data as any).release_time)
        return release.getTime() <= today.getTime()
      })
      .map(([t, ]) => (t))

    const initialDisplayIssue = yearMonthValues.sort((a, b) => Number(b) - Number(a))[0]
    if (initialDisplayIssue) {
      this.$store.commit('SET_MONTH', { month: parseInt(initialDisplayIssue.slice(4)) })
      this.$store.commit('SET_YEAR', { year: parseInt(initialDisplayIssue.slice(0, 4)) })
    } else {
      this.$store.commit('SET_MONTH', { month: null })
      this.$store.commit('SET_YEAR', { year: null })
    }
  },
  methods: {
    scrollToAnchorPoint(refName: string) {
      const testRef = this.childRefs[refName]
      testRef[0].scrollIntoView({ behavior: 'smooth' })
    }
  },
})
